import React from 'react'
import ContactForm from './ContactForm'
import { ContactWrapper } from './Styled'
import { Col, Container, Row } from 'react-bootstrap'
import { TextButton, TextWithIcon } from '../../../ui/CustomElements'
import { Box, MainHeading, SpanStyled, SubHeadingStyled, TextStyled, } from '../../../ui/Elements'
import { ContactEmail, ContactFacebook, ContactInstagram, ContactLinkedin, ContactPhone, ContactSnapchat, ContactX, LinkedIn, LoactionIcon, SnapChat, Tiktok } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Footer from '../../footer/Footer'
// import Footer from '../../footer/Footer'

const Contact = () => {
	const WhatsApp = () => {
        const phoneNumber = '+966963852741';
        const message = 'Hello, this is My Office';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
	const Map = ""
	const { t } = useTranslation();
	const socialIcon = [
		{
            img: <ContactFacebook/>,
            link: 'https://www.facebook.com',
        },
		{
            img: <ContactX />,
            link: 'https://x.com/',
        },
		{
            img: <ContactInstagram />,
            link: 'https://www.instagram.com/',
        },
        {
            img: <ContactSnapchat />,
            link: 'https://snapchat.com/',
        },
		// {
        //     img: <Tiktok />,
        //     link: 'https://www.tiktok.com/@user3666835522780?_t=ZS-8ztPKClli3p&_r=1',
        // },
		
        // {
        //     img: <ContactLinkedin />,
        //     link: 'https://www.linkedin.com/',
        // },
    ]
	return (
		<>
			<ContactWrapper id='contact' className='contact-bg container-fluid'>

				<Container>
					<Box className='containerContact'>
						<Row>
							
							{/* <Col lg={6} md={12} className='contact-Us'>
								<Box className='contactDetailCol'>
									
									<Box className='contactComBox no-border mb-4'>
										<SpanStyled className='d-flex contactdesc' family="var(--medium)" color='var(--white)' size="22px">
											{t('haveQuestions')}
										</SpanStyled>
									</Box>
									
									<Box className='contactComBox'>
										
										<Box className='contact-info'>
											<TextButton clName="dgts" icon={ContactPhone} label='+966 963 852 741' onClick={WhatsApp} color="var(--white)" />
										</Box>
									</Box>
									<Box className='contactComBox'>
										<Box className='contact-info'>
											<TextWithIcon icon={ContactEmail} title='Info@myoffice.com' href="mailto:Info@myoffice.com" color="var(--white)" />
										</Box>
									</Box>
									<Box className='contactComBox'>
										<Box className='contact-info'>
											<TextWithIcon icon={LoactionIcon} title="Al Ta'aown Dist.,, P.O.Box : 513" color="var(--white)" />
										</Box>
									</Box>
									<Box className='contactComBox no-border contactComBoxSocial'>
										<Box className='contactComHeading pb-0'>
											{t('followUs')}
										</Box>
										<Box className='Social-links'>
											{
												socialIcon.map((list, key) => (
													<a href={list.link} target="_blank" key={key} className='contact-links'>
														{list.img}
													</a>
												))
											}
										</Box>
									</Box>

									
								</Box>
								
								
								
							</Col> */}
							<Col lg={12} md={12} className='contact-Us-detail'>
								<Box className='contect-with-us'>
									<Box className='contactHeadings'>
										<MainHeading className='main-heading' color="var(--white)">
											{t('getInTouch')}
										</MainHeading>
										<SpanStyled className='mb-4' size="18px" color='var(--white)'>
											{t('getInTouch_desc')}
										</SpanStyled>
									</Box>
									<ContactForm />
								</Box>
							</Col>
						</Row>
					</Box>
					<Footer />
				</Container>
				
			</ContactWrapper>
		</>
	)
}

export default Contact